import { useState, useEffect } from 'react';
import api from '../api';

export default function ActivityLog() {
  const [logins,   setLogins]   = useState([]);
  const [activity, setActivity] = useState([]);
  const [tab,      setTab]      = useState('logins');
  const [search,   setSearch]   = useState('');

  useEffect(() => {
    api.get('/logs/logins?limit=200').then(r => setLogins(r.data)).catch(() => {});
    api.get('/logs/activity?limit=200').then(r => setActivity(r.data)).catch(() => {});
  }, []);

  const filteredLogins = logins.filter(l =>
    !search || l.email?.toLowerCase().includes(search.toLowerCase()) || l.ip_address?.includes(search)
  );
  const filteredActivity = activity.filter(a =>
    !search || a.email?.toLowerCase().includes(search.toLowerCase()) || a.action?.toLowerCase().includes(search.toLowerCase())
  );

  function roleLabel(r) {
    return r === 'admin' ? <span className="badge badge-info">Admin</span>
         : <span className="badge badge-success">Klientas</span>;
  }

  return (
    <div>
      <div className="page-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div>
          <div className="page-title">Veiklos žurnalas</div>
          <div className="page-subtitle">Prisijungimų istorija ir sisteminiai įvykiai</div>
        </div>
        <input className="filter-input" placeholder="🔍 Ieškoti..." value={search} onChange={e => setSearch(e.target.value)} style={{ width:260 }} />
      </div>

      {/* Stats */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:16, marginBottom:24 }}>
        {[
          { label:'Prisijungimai', value: logins.filter(l=>l.success).length, color:'#10b981', icon:'✅' },
          { label:'Nesėkmingi', value: logins.filter(l=>!l.success).length, color:'#ef4444', icon:'❌' },
          { label:'Unikalūs vartotojai', value: new Set(logins.map(l=>l.email)).size, color:'#3b82f6', icon:'👤' },
          { label:'Veiksmų iš viso', value: activity.length, color:'#8b5cf6', icon:'📝' },
        ].map(s => (
          <div key={s.label} className="card" style={{ textAlign:'center' }}>
            <div style={{ fontSize:24 }}>{s.icon}</div>
            <div style={{ fontSize:28, fontWeight:800, color:s.color }}>{s.value}</div>
            <div style={{ fontSize:12, color:'var(--text-muted)' }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="card" style={{ padding:0 }}>
        <div style={{ display:'flex', borderBottom:'1px solid var(--border)' }}>
          {[['logins','🔑 Prisijungimai'],['activity','📝 Veikla']].map(([key,label]) => (
            <button key={key} onClick={() => setTab(key)} style={{
              padding:'12px 20px', background:'none', border:'none', cursor:'pointer',
              fontWeight: tab===key ? 700 : 400,
              color: tab===key ? 'var(--accent)' : 'var(--text-muted)',
              borderBottom: tab===key ? '2px solid var(--accent)' : '2px solid transparent',
              fontSize:13
            }}>{label}</button>
          ))}
        </div>

        <div className="table-wrap">
          {tab === 'logins' ? (
            <table>
              <thead><tr><th>Data ir laikas</th><th>El. paštas</th><th>Rolė</th><th>IP adresas</th><th>Rezultatas</th></tr></thead>
              <tbody>
                {filteredLogins.map((l,i) => (
                  <tr key={i}>
                    <td style={{ fontSize:12, color:'var(--text-muted)', whiteSpace:'nowrap' }}>{new Date(l.created_at).toLocaleString('lt-LT')}</td>
                    <td>{l.email}</td>
                    <td>{roleLabel(l.role)}</td>
                    <td style={{ fontSize:12, fontFamily:'monospace' }}>{l.ip_address || '—'}</td>
                    <td>
                      {l.success
                        ? <span className="badge badge-success">✅ Sėkmingas</span>
                        : <span className="badge badge-danger">❌ Nesėkmingas</span>}
                    </td>
                  </tr>
                ))}
                {!filteredLogins.length && <tr><td colSpan={5} style={{ textAlign:'center', color:'var(--text-muted)', padding:40 }}>Įrašų nėra</td></tr>}
              </tbody>
            </table>
          ) : (
            <table>
              <thead><tr><th>Data ir laikas</th><th>Vartotojas</th><th>Rolė</th><th>Veiksmas</th><th>Detalės</th><th>IP</th></tr></thead>
              <tbody>
                {filteredActivity.map((a,i) => (
                  <tr key={i}>
                    <td style={{ fontSize:12, color:'var(--text-muted)', whiteSpace:'nowrap' }}>{new Date(a.created_at).toLocaleString('lt-LT')}</td>
                    <td>{a.email}</td>
                    <td>{roleLabel(a.role)}</td>
                    <td><span className="badge badge-info">{a.action}</span></td>
                    <td style={{ fontSize:12, color:'var(--text-muted)', maxWidth:300 }}>{a.details || '—'}</td>
                    <td style={{ fontSize:12, fontFamily:'monospace' }}>{a.ip_address || '—'}</td>
                  </tr>
                ))}
                {!filteredActivity.length && <tr><td colSpan={6} style={{ textAlign:'center', color:'var(--text-muted)', padding:40 }}>Įrašų nėra</td></tr>}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
